export const collectionName = 'testlets';
export const contentTypeField = 'content_type';
export const contentStatusField = 'testlet_type';
export const isDeletedField = 'is_deleted';
export const createdByIdField = 'created_by';
export const updatedOnField = 'updated_on';
